<template>
  <ul class="footer-socials__wrapper">
    <li v-for="item in items" :key="item.Id" class="footer-socials__item">
      <div class="footer-socials__image-wrapper">
        <a-image
          :image="item.Logo"
          :aspect-ratio="aspectRatios.footerStayConnected"
          :url="item.Url"
          :open-in-new-tab="item.OpenInNewTab"
          :directives="item.Directives"
          class="footer-socials__icon"
        />
      </div>
    </li>
  </ul>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import { aspectRatios } from 'enums/aspectRatios'

export default {
  name: 'FooterSocials',
  props: {
    items: propValidator([PROP_TYPES.ARRAY])
  },
  data() {
    return { aspectRatios }
  }
}
</script>

<style lang="scss" scoped>
.footer-socials__wrapper {
  margin-top: 24px;
  display: flex;
  flex-wrap: wrap;

  & > * {
    margin-right: 16px;
    margin-bottom: 24px;
  }

  & > *:last-child {
    margin-right: 0;
  }

  @include tablet {
    & > * {
      margin-right: 14px;
    }
  }

  @include mobile {
    & > * {
      margin-bottom: 0;
    }
  }
}

/deep/ .footer-socials__icon .a-icon__icon {
  fill: $c--white;

  &:hover {
    fill: $c--main;
  }
}

.footer-socials__image-wrapper {
  width: 22px;
  height: 22px;
}
</style>
